import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'

import { ar, en, fr } from '@/config/locales'

const resources = {
  en: en,
  fr: fr,
  ar: ar
}

export type SupportedLanguages = keyof typeof resources

export const APP_SUPPORTED_LANGUAGES = Object.keys(resources)

i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    returnNull: false,
    resources,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    },
    //   TODO: delete when translation is ready
    lng: 'en'
  })

export default i18n
